<template>
  <router-view/>
</template>

<style>
#app {
  font-family: var(--font-sans);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
